module.exports = "/ios22b2466658f6c3b516b3a9fd681b8fb3.svg";